// extracted by mini-css-extract-plugin
export default {"key":"Key_key__1GgIB"};